const DEFAULT_APP_URL = "https://amcarehub.com";

export function getAppBaseUrl(): string {
  const configured =
    import.meta.env.VITE_APP_URL ||
    import.meta.env.VITE_PRODUCTION_URL;

  if (configured) {
    return String(configured).replace(/\/$/, "");
  }

  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1" || host.endsWith(".local");

  if (isLocal) {
    return DEFAULT_APP_URL;
  }

  return window.location.origin;
}

export function getAuthRedirectUrl(path: string = ""): string {
  const base = getAppBaseUrl();
  const normalizedPath = path ? (path.startsWith("/") ? path : `/${path}`) : "";
  return `${base}${normalizedPath}`;
}
